import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { DonateButton } from "./DonateButton";
import { ShareButton } from "./ShareButton";

export function ParticipantProfile({
  name,
  profileImage,
  intro,
  fundraiserSlug,
  fundraiserTitle,
  participantSlug,
}) {
  const firstName = name.split(" ")[0];

  return (
    <section className="bg-[#efc94c] py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <Link
              to={`/fundraiser/${fundraiserSlug}`}
              className="inline-flex items-center gap-2 text-white hover:opacity-80 font-medium transition"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to {fundraiserTitle}
            </Link>
            <ShareButton
              label="Share"
              variant="solid"
              url={`${window.location.origin}/fundraiser/${fundraiserSlug}/${participantSlug}`}
              title={`Support ${name} — ${fundraiserTitle}`}
            />
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-80 md:shrink-0">
                <img
                  src={profileImage}
                  alt={name}
                  className="w-full h-64 md:h-full object-cover"
                />
              </div>
              <div className="flex-1 p-6 md:p-10 flex flex-col justify-center text-center md:text-left">
                <p className="text-sm font-bold uppercase tracking-widest text-[#FF6600] mb-2">
                  Support My Journey
                </p>
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                  Hi, I'm {firstName}!
                </h1>
                {intro && (
                  <p className="text-gray-600 text-lg mt-4">{intro}</p>
                )}
                <div className="mt-6">
                  <DonateButton
                    label="Donate Now"
                    className="px-8 py-3 text-lg"
                    fundraiserId={fundraiserSlug}
                    fundraiserTitle={fundraiserTitle}
                    paymentFor="PARTICIPANT"
                    participantId={participantSlug}
                    participantName={name}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
